import Component from 'components/pages/OfferLandingPage/OfferLandingPage';
import { buildPage, buildStaticProps } from 'utils/pageHelper';

export const getServerSideProps = buildStaticProps('cashbacks', {
  offerType: 'cashback',
  withoutHeaderOnMobile: true,
  withoutFooterOnMobile: true,
});
export default buildPage(Component, {
  skipSSR: true,
  requiresAuthentication: false,
  metaData: {
    title: 'Cashback Offer',
    description: 'Earn cashback on great products with Qmee.',
  },
});
